<template>
  <div class="SIM-web">
    <div style="background:rgba(249, 249, 249, 1);">
      <div class="flex-box">
        <p class="head-title">{{$t('RedteaSIM.title1')}}</p>
        <div class="img-box">
          <video :src="videoSrc" type="video/mp4" width="320" controls="controls" :poster="poster">
            <p>你的浏览器不支持video标签.</p>
          </video>
        </div>
        <p class="content">{{$t('RedteaSIM.des1')}}</p>
        <p class="content">{{$t('RedteaSIM.des2')}}</p>
        <a href="https://app.redteago.com/?lang=en" target="blank">
          <p class="img-more">
            {{$t('LEARN')}}&nbsp;&nbsp;
            <img
              src="../assets/go-mobile/跳转 (5).svg"
              style="width:0.11rem;"
            />
          </p>
        </a>
      </div>
    </div>
    <div class="flex-box">
      <p class="title">{{$t('RedteaSIM.title2')}}</p>
      <div class="img-box">
        <img src="../assets/redteaSIM-mobile/Red teaSIM 1 手机@2x.png" />
      </div>
      <p class="content">{{$t('RedteaSIM.content1')}}</p>
      <p class="content">{{$t('RedteaSIM.content2')}}</p>
      <p class="content">{{$t('RedteaSIM.content3')}}</p>
    </div>

    <div class="flex-box">
      <p class="title">{{$t('RedteaSIM.title3')}}</p>
      <div class="img-box">
        <img src="../assets/redteaSIM-mobile/Red tea SIM 2手机@2x.png" />
      </div>
      <p class="content">{{$t('RedteaSIM.content4')}}</p>
      <p class="content">{{$t('RedteaSIM.content5')}}</p>
      <p class="content">{{$t('RedteaSIM.content6')}}</p>
      <p class="content">{{$t('RedteaSIM.content7')}}</p>
    </div>

    <div class="flex-box">
      <p class="title">{{$t('RedteaSIM.title4')}}</p>
      <div class="img-box">
        <img src="../assets/redteaSIM-mobile/RedteaSIM 3手机@2x.png" />
      </div>
      <p class="content">{{$t('RedteaSIM.content8')}}</p>
      <p class="content">{{$t('RedteaSIM.content9')}}</p>
      <p class="content">{{$t('RedteaSIM.content10')}}</p>
      <p class="content">{{$t('RedteaSIM.content11')}}</p>
      <p class="content">{{$t('RedteaSIM.content12')}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RedteaGo-web',
  components: {},
  computed: {
    goImg() {
      return this.$store.state.msimImg
    },
    videoSrc() {
      let src = ''
      if (this.$i18n.locale == 'zh') {
        src = 'https://www.redteamobile.com/RedteaSIM_zh_m.mp4'
      } else {
        src = 'https://www.redteamobile.com/RedteaSIM_en_m.mp4'
      }
      return src
    },
    poster() {
      let src = '../assets/logo.png'
      if (this.$i18n.locale == 'zh') {
        src = 'https://www.redteamobile.com/poster_zh.png'
      } else {
        src = 'https://www.redteamobile.com/poster_en.png'
      }
      return src
    }
  }
}
</script>
<style lang="less" scoped>
.SIM-web {
  text-align: left;
  padding-top: 1.2rem;
  .flex-box {
    padding: 0.2rem;
  }
  .head-title {
    font-family: 'Poppins-Regular';
    font-size: 16px;
    text-align: center;
    margin-bottom: 0.2rem;
  }
  .title {
    font-family: 'Poppins-Regular';
    font-size: 16px;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }
  .content {
    font-family: 'Poppins-ExtraLight';
    font-size: 12px;
    margin-top: 0.2rem;
  }
  .img-more {
    color: rgba(207, 42, 42, 1);
    font-family: 'Poppins-Bold';
    font-size: 0.12rem;
    margin: 0.2rem 0 0.4rem 0;
    text-align: center;
  }
}
</style>
